// site namespace strings — EN + ES. Missing ES keys fall back to EN.
const STRINGS = {
  en: {
    blog_title: "Our Blog",
    blog_subtitle: "Party planning tips, rental guides, and local inspiration from our team.",
    loading_posts: "Loading posts…",
    no_posts: "No blog posts yet — check back soon.",
    read: "Read",
    min_read: "min read",
    all: "All",
    view_in_spanish: "Ver en Español",
    view_in_english: "View in English",
    published_on: "Published",
    by: "By",
    view_all_cities: "View all cities",
    available_in: "Also available in:",
    cities_in: "Cities we serve",
    back_to_blog: "Back to Blog",
  },
  es: {
    blog_title: "Nuestro Blog",
    blog_subtitle: "Consejos para planear fiestas, guías de alquiler y ideas locales de nuestro equipo.",
    loading_posts: "Cargando publicaciones…",
    no_posts: "Aún no hay publicaciones — vuelve pronto.",
    read: "Leer",
    min_read: "min de lectura",
    all: "Todo",
    view_in_spanish: "Ver en Español",
    view_in_english: "Ver en Inglés",
    published_on: "Publicado",
    by: "Por",
    view_all_cities: "Ver todas las ciudades",
    available_in: "También disponible en:",
    cities_in: "Ciudades que servimos",
    back_to_blog: "Volver al Blog",
  },
};

export default STRINGS;
